<template>
  <div id="QuestionClick" class="col-xs-12 col-sm-6 col-md-6 cover">
    <div class="intro_screen question cover" style="opacity: 1;">
      <div class="reading_default">
        <p class="q_count text-center">
          Question<b> {{ question_detail.question_order }} </b>
        </p>
        <h3 class="q_title">
          Look at the four squares [■] that indicate where the following
          sentence could be added to the passage. Where would the sentence best
          fit? Click on a square [■] to add the sentence to the passage.
        </h3>
        <p class="sentence">{{ question_detail.question }}</p>
        <div class="options">
          <div
            class="radio"
            v-for="option in question_detail.options"
            :key="option.id"
          >
            <div>
              <input
                class="magic-radio"
                :value="option.id"
                v-model="theAnswer"
                type="radio"
                :id="option.id"
              />
              <label :for="option.id">{{ option.title }}</label>
            </div>
          </div>
        </div>
        <h5>The corresponding paragraph number is highlighted.</h5>
        <GoogleAd :key="question_detail.id" />
      </div>
    </div>
  </div>
</template>

<script>
import GoogleAd from "@/views/ad/GoogleAd";
export default {
  name: "question-click",
  props: ["question_detail", "answers", "insertOption"],
  components: { GoogleAd },
  data() {
    //不能直接修改answer
    return {
      theAnswer: this.answers[0]
    };
  },
  mounted() {
    this.getAnswer();
  },
  watch: {
    //监听answer进行改变
    answers(value) {
      this.theAnswer = value[0];
    },
    //你的答案
    theAnswer() {
      this.getAnswer();
    },
    insertOption(val) {
      this.question_detail.options.forEach(option => {
        if (this.getOptionVal(option.title) === val) {
          this.theAnswer = option.id;
        }
      });
    }
  },
  methods: {
    getAnswer() {
      let answers = [];
      answers.push(this.theAnswer);
      answers.sort(this.cmp);
      this.$parent.setAnswers(answers);
      this.question_detail.options.forEach(option => {
        if (option.id === this.theAnswer) {
          this.$emit("insertPassage", this.getOptionVal(option.title));
        }
      });
    },
    cmp(a, b) {
      return a - b;
    },
    getOptionVal(val) {
      let str = val;
      if (val.indexOf("A.") != -1) {
        str = "A";
      }
      if (val.indexOf("B.") != -1) {
        str = "B";
      }
      if (val.indexOf("C.") != -1) {
        str = "C";
      }
      if (val.indexOf("D.") != -1) {
        str = "D";
      }
      return str;
    }
  }
};
</script>
<style src="@/views/toefl/toeflTest/style/tpo.css" scoped></style>
<style scoped>
.sentence {
  border: 1px solid #cacbcc;
  background-color: #f2f3f5;
  padding: 10px;
  margin: 20px 5px;
}
</style>
